import React, { Component } from 'react'
import Item from '../../../item'
// import names from '../../../../data/names'
import './SearchScreen.css'

export default class SearchScreen extends Component {
    state = {
        value: "",
        itemsUrl:"https://us-central1-merching-d1890.cloudfunctions.net/items",
        // itemsUrl:"http://localhost:5000/merching-d1890/us-central1/items",
        list:[]
    }

    componentWillMount() {
        fetch(this.state.itemsUrl)
            .then(e => e.json())
            .then(list => this.setState({...this.state,list}))
    }

    filter = e => { 
        const { value } = e.target;
        this.setState({
            ...this.state,
            value
        }) 
    }

    itemList = () => {
        const {value} = this.state
        const ids = this.props.items.map(e=>e.id)
        const results = this.state.list
            .filter(e => e.name.toLowerCase().indexOf(value.toLowerCase()) > -1)
            .map(e => {
                const method = ids.indexOf(e.id) > -1 ? "min" : "add"
                return <Item key={e.id} type={method} name={e.name} id={e.id} />
            })
        return results.length > 0
            ? results
            : <div>{`No results are found for : ${this.state.value}.`}</div> 
    }

    render() {
        return (
            <div className="Search">
                <input
                    type="search"
                    autoFocus
                    autoComplete="off"
                    name="searching for the correct items"
                    className={this.itemList() ? "active" : ""}
                    value={this.state.value} onChange={this.filter}
                    placeholder="Search..." />
                <div className='listContainer' ref={e => this.list = e}>
                    {
                        this.state.value.length > 2 
                            ? this.itemList() 
                            : <div>Search box must contain at least three letters</div> 
                    }
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/ui/screens/HomeScreen/SearchScreen/index.js